export const capitalCities = {
  AB: {
    name: 'Edmonton',
    location: {
      lat: 53.560199139751184,
      lng: -113.49204135851619
    }
  },
  BC: {
    name: 'Victoria',
    location: {
      lat: 48.4262362,
      lng: -123.3767321
    }
  },
  MB: {
    name: 'Winnipeg',
    location: {
      lat: 49.853959,
      lng: -97.2923067
    }
  },
  NB: {
    name: 'Fredericton',
    location: {
      lat: 45.9636,
      lng: -66.6431
    }
  },
  NL: {
    name: "St. John's",
    location: {
      lat: 47.5615,
      lng: -52.7126
    }
  },
  NT: {
    name: 'Yellowknife',
    location: {
      lat: 62.4540,
      lng: -114.3718
    }
  },
  NS: {
    name: 'Halifax',
    location: {
      lat: 44.6488,
      lng: -63.5752
    }
  },
  NU: {
    name: 'Iqaluit',
    location: {
      lat: 63.7467,
      lng: -68.5170
    }
  },
  ON: {
    name: 'Toronto',
    location: {
      lat: 43.65584119777959,
      lng: -79.36158511231376
    }
  },
  PE: {
    name: 'Charlottetown',
    location: {
      lat: 46.2382,
      lng: -63.1311
    }
  },
  QC: {
    name: 'Québec',
    location: {
      lat: 46.8139,
      lng: -71.2080
    }
  },
  SK: {
    name: 'Regina',
    location: {
      lat: 50.4452,
      lng: -104.6189
    }
  },
  YT: {
    name: 'Whitehorse',
    location: {
      lat: 60.7212,
      lng: -135.0568
    }
  },
};

export const CBB = {
  TOKEN_MINUTES: 60,
  CUSTOMER_ID: process.env.REACT_APP_CBB_CUSTOMERID,
  USERNAME: process.env.REACT_APP_CBB_USERNAME,
  PASSWORD: process.env.REACT_APP_CBB_PASSWORD,
  GET_TOKEN_URL: 'https://service.canadianblackbook.com/UsedCarWS/CanUsedAPI/Token/Get',
  AUTO_COMPLETE_URL: 'https://service.canadianblackbook.com/UsedCarWS/CanUsedAPI/Autocomplete',
  TRADE_VALUES_URL: 'https://service.canadianblackbook.com/UsedCarWS/CanUsedAPI/UsedVehicle/UVC',
}

export const localStorageKeys = {
  DEALER_SELECTED_BY_USER: 'dealerSelectedByUser',
  USER_GEO_LOCATION: 'userGeoLocation',
  USER_POSTALCODE: 'userPostalCode',
}